// Managed Services offerings - three tiers
export const managedServicesTiers = [
  {
    id: 'elevate',
    name: 'Pratham Elevate',
    subtitle: 'Basic Tier',
    tagline: 'Foundational monitoring with defined SLAs',
    description: 'Essential cloud support and governance for teams starting their managed operations journey. Ideal for lean workloads and single-environment production setups.',
    idealFor: 'Startups & SMBs with a single production environment',
    highlight: false,
    icon: 'Shield',
    features: [
      'Cloud Infrastructure Support',
      'Billing Management',
      'Limited Service Requests — 20 per year',
      'Cloud Infrastructure — Basic Monitoring',
      'Quarterly MSP review report',
      'Production Environment Synthetic monitoring — up to 2 links',
      'Customer Support portal — 1 customer user'
    ],
    support: '8 x 5 support coverage',
    srSLA: [
      { sev: 'Critical', response: '3 hrs', resolution: '8 hrs' },
      { sev: 'Major', response: '4 hrs', resolution: '18 hrs' },
      { sev: 'Moderate', response: '6 hrs', resolution: '26 hrs' },
      { sev: 'Minor', response: '8 hrs', resolution: '32 hrs' },
    ],
    incidentSLA: [
      { sev: 'Critical', response: '1 hr', resolution: '4 hrs' },
      { sev: 'Major', response: '1 hr', resolution: '8 hrs' },
      { sev: 'Moderate', response: '1 hr', resolution: '24 hrs' },
      { sev: 'Minor', response: '1 hr', resolution: '48 hrs' },
    ],
    addons: []
  },
  {
    id: 'advance',
    name: 'Pratham Advance',
    subtitle: 'Mid Tier',
    tagline: 'Unlimited support with advanced observability',
    description: 'A comprehensive package with unlimited requests, richer monitoring, and expanded environments for growing businesses that need reliable 24 x 7 coverage on critical workloads.',
    idealFor: 'Growing companies with UAT + production workloads',
    highlight: true,
    icon: 'Zap',
    features: [
      'Cloud Infrastructure Support',
      'Billing Management',
      'Logs Management Tool',
      'Unlimited number of Service Requests',
      'Cloud Infrastructure — Advanced Monitoring Tool',
      'Infrastructure monitoring Dashboards',
      'Production and UAT Synthetic monitoring — unlimited links',
      'Customer Support Portal — 3 customer users',
      'Monthly MSP review report',
      'Yearly Well-Architected Review Report',
      'Quarterly Security Standards Enhancement'
    ],
    support: '24 x 7 support for critical incidents',
    srSLA: [
      { sev: 'Critical', response: '1 hr', resolution: '4 hrs' },
      { sev: 'Major', response: '1 hr', resolution: '8 hrs' },
      { sev: 'Moderate', response: '4 hrs', resolution: '12 hrs' },
      { sev: 'Minor', response: '8 hrs', resolution: '16 hrs' },
    ],
    incidentSLA: [
      { sev: 'Critical', response: '30 min', resolution: '2 hrs' },
      { sev: 'Major', response: '30 min', resolution: '8 hrs' },
      { sev: 'Moderate', response: '30 min', resolution: '16 hrs' },
      { sev: 'Minor', response: '30 min', resolution: '24 hrs' },
    ],
    addons: ['SIEM Tool', 'Logs Management Tool']
  },
  {
    id: 'ultimate',
    name: 'Pratham Ultimate',
    subtitle: 'Enterprise Tier',
    tagline: 'AI-driven enterprise cloud optimization',
    description: 'Our most comprehensive tier — AI-powered alerting, application performance monitoring, and continuous optimization for mission-critical, enterprise-scale cloud estates.',
    idealFor: 'Enterprises with mission-critical, multi-environment cloud',
    highlight: false,
    icon: 'Sparkles',
    features: [
      'Cloud Infrastructure Support',
      'Billing Management',
      'Logs Management Tool',
      'Advanced Billing Dashboards with cost alerting',
      'Unlimited number of Service Requests',
      'Cloud Infrastructure — Advanced Monitoring Tool',
      'Application Monitoring Solution — APM',
      'Advanced Alerting Tool using AI',
      'Infrastructure monitoring Dashboards',
      'All Environments Synthetic monitoring — unlimited links',
      'Customer Support Portal — unlimited users',
      'Monthly MSP review report',
      'Quarterly Well-Architected Review Report',
      'Monthly Security Standards Enhancement',
      'Monthly Cloud Account Security Report',
      'Quarterly cost optimization review'
    ],
    support: '24 x 7 dedicated enterprise support',
    srSLA: [
      { sev: 'Critical', response: '30 min', resolution: '2 hrs' },
      { sev: 'Major', response: '1 hr', resolution: '5 hrs' },
      { sev: 'Moderate', response: '2 hrs', resolution: '10 hrs' },
      { sev: 'Minor', response: '4 hrs', resolution: '20 hrs' },
    ],
    incidentSLA: [
      { sev: 'Critical', response: '15 min', resolution: '1 hr' },
      { sev: 'Major', response: '15 min', resolution: '4 hrs' },
      { sev: 'Moderate', response: '15 min', resolution: '8 hrs' },
      { sev: 'Minor', response: '15 min', resolution: '16 hrs' },
    ],
    addons: [
      'SIEM Tool',
      'Logs Management Tool',
      'Quarterly Review & report for Backup Policy',
      'Quarterly Review & report for Tagging Policy'
    ]
  }
];
